import { render, staticRenderFns } from "./ThirdForm.vue?vue&type=template&id=6a670bd5&"
import script from "./ThirdForm.vue?vue&type=script&lang=js&"
export * from "./ThirdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports